import { Control, Controller } from 'react-hook-form';

import { CompactClubTable } from '@blocks';
import { ClubCollections } from '@data';
import { useTranslate } from '@i18n';
import { Stack, u, Box, Spinner, Text, Inline } from '@ui';

import * as css from '../UserWelcomeWizard.css';
import { UserWelcomeWizardForm } from '../useUserWelcomeWizard';

type GolfBagStepProps = {
    control: Control<UserWelcomeWizardForm>;
    clubs?: ClubCollections;
    isLoading: boolean;
};

export const GolfBagStep = ({ control, clubs, isLoading }: GolfBagStepProps) => {
    const t = useTranslate();

    return (
        <Controller
            control={control}
            name="clubIds"
            render={({ field }) => {
                const handleToggleClub = (clubId: number) => {
                    field.onChange(
                        field.value.includes(clubId)
                            ? field.value.filter((currentClubId) => currentClubId !== clubId)
                            : [...field.value, clubId],
                    );
                };

                return (
                    <Stack gap={u(2)}>
                        <Box p={u(2)} className={css.sectionCard}>
                            {isLoading ? (
                                <Box display="flex" justifyContent="center" p={u(4)}>
                                    <Spinner size="m" />
                                </Box>
                            ) : clubs ? (
                                <CompactClubTable
                                    clubCollections={clubs}
                                    displaySelectedClubIds={field.value}
                                    onClick={handleToggleClub}
                                    wrap
                                />
                            ) : (
                                <Text color="danger">{t('user_welcome_wizard.bag_error')}</Text>
                            )}
                        </Box>
                        <Inline alignItems="center" justifyContent="space-between" className={css.selectedSummary}>
                            <Stack gap={u(0.5)}>
                                <Text variant="h4">{t('user_welcome_wizard.bag_selected_title')}</Text>
                                <Text variant="pSmall" color="muted">
                                    {field.value.length} {t('user_welcome_wizard.bag_selected_body')}
                                </Text>
                            </Stack>
                        </Inline>
                    </Stack>
                );
            }}
        />
    );
};
